import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({
  title,
  description,
  canonical,
  robots = 'index, follow',
  ogTitle,
  ogDescription,
  ogUrl,
  ogType = 'website',
}) {
  const oTitle = ogTitle || title;
  const oDesc = ogDescription || description;
  const oUrl = ogUrl || canonical;

  return (
    <Helmet prioritizeSeoTags>
      <html lang="hu" />
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={oTitle} />
      {oDesc ? <meta property="og:description" content={oDesc} /> : null}
      <meta property="og:url" content={oUrl} />
      <meta property="og:locale" content="hu_HU" />
    </Helmet>
  );
}
